// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const avalugg_hisui: PokeData = {
  "id": 10243,
  "name": "avalugg-hisui",
  "height": 14,
  "weight": 2624,
  "base_experience": 180,
  "types": [
    PokeType.ICE,
    PokeType.ROCK
  ],
  "api_moves": [
    "tackle",
    "take-down",
    "double-edge",
    "bite",
    "blizzard",
    "recover",
    "harden",
    "rock-slide",
    "curse",
    "powder-snow",
    "protect",
    "icy-wind",
    "rapid-spin",
    "crunch",
    "iron-defense",
    "earth-power",
    "avalanche",
    "ice-shard",
    "ice-fang",
    "stone-edge",
    "wide-guard",
    "mountain-gale"
  ],
  "moves": [
    "tackle",
    "bite",
    "blizzard",
    "rock-slide",
    "curse",
    "protect",
    "crunch",
    "earth-power",
    "avalanche",
    "ice-shard",
    "ice-fang",
    "power-siphon",
    "rock-smash"
  ],
  "evolution_chain": {
    "id": 366,
    "item": null,
    "species": [
      {
        "name": "bergmite",
        "order": 712,
        "types": [
          PokeType.ICE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "avalugg",
        "order": 713,
        "types": [
          PokeType.ICE
        ],
        "evolves_from_species_id": 712,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 37,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 153,
    "speed": 57,
    "ability_power": 190
  },
  "stat_changes": [],
  "catch_rate": 55,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": "hisui"
} as const;
